module.exports = __webpack_public_path__ + "img/19.c071b315.jpg";